import api from "@helpers/api";

import { URLS } from "@constants/urls";

const apiEndPoint = `http://127.0.0.1:7077/${URLS.EMPLOYEES}/10/${URLS.PROVIDENT_FUNDS}`;

export const getProvidentFunds = (() => {
  return async ({ payload }: any): Promise<{ data: any }> => {
    return api.get(apiEndPoint).then((response) => {
      const { loans, employeeMasterId } = response.data;

      return {
        data: loans,
        employeeMasterId,
      };
    });
  };
})();

export const addNewLoan = (() => {
  return async (data: { data: any }): Promise<{ data: any }> => {
    return api.post(URLS.CREATE_NEW_LOAN, { ...data }).then((response) => {
      return { data: response.data.result };
    });
  };
})();
